export * from './related-equipments.component';
